import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  error?: any;
  brand: string;
  intl: any;
}

const ResumeSubscriptionModal = (props: Props) => {
  const { open, onClose, onConfirm, loading, error, brand } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="resume-dialog-title"
      aria-describedby="resume-dialog-description">
      <DialogTitle id="resume-dialog-title" style={{ fontWeight: 'bold' }}>
        <FormattedMessage id="resumeModalTitle" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="resume-dialog-description">
          <FormattedMessage id="resumeModalMessage" />
        </DialogContentText>
        {error && (
          <DialogContentText id="resume-dialog-error" style={{ color: '#f44336', marginTop: '10px' }}>
            <FormattedMessage
              id="resumeError"
              defaultMessage="An error occurred while resuming your subscription. Please try again."
            />
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions id="resume-dialog-actions">
        <Button
          onClick={onClose}
          className={`${brand}-btn-text`}
          style={{ textTransform: 'none' }}
          disabled={loading}
          id="resume-cancel-btn">
          <FormattedMessage id="cancel" />
        </Button>
        <Button
          onClick={onConfirm}
          className={`${brand}-btn ${brand}-btn-action`}
          style={{
            width: 165,
            textTransform: 'none',
            height: 42,
            fontWeight: 'bolder',
          }}
          disabled={loading}
          autoFocus
          id="resume-confirm-btn">
          <>
            {loading ? (
              <CircularProgress
                size={24}
                className={`${brand}-migration-model-progress`}
                style={{ marginRight: '10px' }}
              />
            ) : null}
            <FormattedMessage id="resumeModalConfirm" />
          </>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(ResumeSubscriptionModal);
